module.exports = __webpack_public_path__ + "static/media/08.86053255.png";